import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';
import { permissionsHelper } from '../../helpers/permissions.helper';
import { AuthService } from '../../core/servises/auth/auth.service';
import * as AuthActions from '../../auth/store/actions/auth.actions';

@Injectable({
  providedIn: 'root',
})
export class PermissionsResolver {
  constructor(
    private _dataService: AuthService,
    private _store: Store,
  ) {}

  public resolve(): Observable<string[]> {
    return this._dataService.getUserData()
      .pipe(
        tap(userData => {
          this._store.dispatch(AuthActions.setSharedOrgs({
            sharedOrganizations: userData.shared_orgs,
          }));
        }),
        map(userData => permissionsHelper(userData.scopes)),
      );
  }
}
